export default {
    MAC_RULE: '^[A-Fa-f\\d]{2}[-][A-Fa-f\\d]{2}[-][A-Fa-f\\d]{2}[-][A-Fa-f\\d]{2}[-][A-Fa-f\\d]{2}[-][A-Fa-f\\d]{2}$',
    USERCAPTION_RULE: '^(?!\\s)[\\u4e00-\\u9fa5A-Za-z0-9\\_\\.\\-\\#\\s]{1,20}(?<!\\s)$',
    ROLECAPTION_RULE: '^(?!\\s)[\\u4e00-\\u9fa5A-Za-z0-9\\_\\.\\-\\#\\s]{1,10}(?<!\\s)$',
    ORDER_RULE: '^[1-9][0-9]*$',
    SELECT_PARAMS: '^[\\u4e00-\\u9fa5A-Za-z0-9\\_\\.\\-\\#]+(,[\\u4e00-\\u9fa5A-Za-z0-9\\_\\.\\-\\#]+)*$',
    AUTH_STR: '^[A-Za-z]+$',
    RES_TYPE_ID: '^\\d{1,5}$',
    SYS_FLG: '^[A-Za-z]+$',
    URL_RULE_PRO: '^(https?):\\/\\/([\\w\\-]+(\\.[\\w-]+)*\\/)*[\\w\\-]+(\\.[\\w\\-]+)*\\/?(\\?([\\w\\-\\.,@?^=%&:\\/~\\+#]*)+)?',
    INPUT_RULE: '^.{1,20}$',

    IP_RULE:
        '^([1-9]|[1-9]\\d|(1\\d{2}|2[0-4]\\d|2[0-5][0-5]))\\.([0-9]|[1-9]\\d|(1\\d{2}|2[0-4]\\d|2[0-5][0-5]))\\.([0-9]|[1-9]\\d|(1\\d{2}|2[0-4]\\d|2[0-5][0-5]))\\.([0-9]|[1-9]\\d|(1\\d{2}|2[0-4]\\d|2[0-5][0-5]))$',
    CAPTION_RULE: '^(?!\\s)[\\u4e00-\\u9fa5A-Za-z0-9\\_\\.\\-\\#\\s]+(?<!\\s)$',
    QUEUE_CAPTION_RULE: '^[A-Za-z0-9\\_\\.\\-\\#]+$',
    ONLY_NUMBER: '[0-9]+',
    PASSWORD_RULE: '^[A-Za-z0-9]+$',
    ROUTING_KEY_RULE: '^[A-Za-z0-9\\,\\.\\*\\#]+$',
    URL_RULE: '[a-zA-z]+://[^s]*',
    URL: '[a-zA-z]+://[A-Za-z0-9/_,.:]*',
    SUB_URL: '/[A-Za-z0-9/_,.:]+',
    CLASS_PATH: '^[A-Za-z0-9\\.]+$',
    NUM: '^[0-9]*\\d$',
    TIME: '0[0-9]:[0-5][0-9]|1[0-9]:[0-5][0-9]|2[0-3]:[0-5][0-9]',
    PODT_CODE: '^[0-9]{6}$',
    SQL_CODE: "^[^']*$"
};
